// extracted by mini-css-extract-plugin
module.exports = {"color":"styles_color__2RwqJ","input":"styles_input__3P2-g"};